import React from 'react'
import styles from './Hero.scss'
import base from 'lib/styleguide/base.scss'
import preloadImg from 'lib/preloadImg'
import cx from 'classnames'

// IE11-compatible retina-ready hero component that can switch backgrounds
// if the window is moved between a non-retina and retina display.
export class Hero extends React.PureComponent {
  static defaultProps = {
    marginBottom: '50px',
    focalPoint: 'center center',
    scrimOpacity: [0.2, 0.6],
    blur: false
  }

  constructor (props) {
    super(props)
    this.state = {
      retina: window.devicePixelRatio > 1.5,
      retinaLoaded: window.devicePixelRatio > 1.5
    }
  }

  componentDidMount () {
    const { retina } = this.state
    if (!retina) {
      this._mediaquery = window.matchMedia('screen and (min-resolution: 2dppx)')
      this._mediaquery.addListener(this.onScreenDensityChange)
    }
  }

  componentWillUnmount () {
    const { retina } = this.state
    if (!retina) {
      this._mediaquery.removeListener(this.onScreenDensityChange)
    }
  }

  onScreenDensityChange = () => {
    const { img2x } = this.props

    if (window.devicePixelRatio > 1.5) {
      this.setState({ retina: true })
      preloadImg(img2x).then(() => this.setState({ retinaLoaded: true }))
      // we don't care about changes any more, since it will just cost more
      // bandwidth to switch from a 2x image to a 1x image
      this._mediaquery.removeListener(this.onScreenDensityChange)
    }
  }

  render () {
    const {
      img,
      img2x,
      label,
      children,
      marginBottom,
      focalPoint,
      scrimOpacity,
      className,
      blur,
      small
    } = this.props

    const { retina, retinaLoaded } = this.state
    const bg = retina && retinaLoaded ? img2x : img
    const scrim = `linear-gradient(to bottom, rgba(0,0,0,${scrimOpacity[0]}) 0%, rgba(0,0,0,${scrimOpacity[1]}) 100%)`
    const background = `url(${bg}) ${focalPoint}/cover no-repeat`

    return (
      <div className={cx(styles.Hero, blur && styles.hasBlur, className)} style={{ marginBottom }}>
        <div className={styles.scrim} style={{ background: scrim }} />
        {/* being able to use img srcset with object-fit:cover would be nice here, but IE11 says no :( */}
        <div className={cx(styles.background, blur && styles.blur)} style={{ background }} />
        <div className={styles.centered}>
          {label && <h1 className={cx(base.contentLabel, styles.contentLabel)}>{label}</h1>}
          <div className={small ? styles.contentSmall : styles.content}>
            {children}
          </div>
        </div>
      </div>
    )
  }
}
